// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"692b45e1","683":"692b45e1","749":"fe10646b"}[chunkId] + ".chunk.css";
};